import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconUserStyle0 = cosmosIconCss;

const CosmosIconUser$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUser extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3834830de4aa711896fc7fd09338a95384d371e6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fec208757a44cf3b1bf1a817d323b6717ad7e33e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2abb18d2c51fc16a075b7abd4c2fe575f22775c8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.006 13.75a3.612 3.612 0 0 1-3.659-3.398l-.295-2.606a3.946 3.946 0 0 1 .86-3.188 4.008 4.008 0 0 1 3.094-1.308A4.004 4.004 0 0 1 14.1 4.56a3.954 3.954 0 0 1 .857 3.206l-.292 2.588a3.614 3.614 0 0 1-3.66 3.396Zm0-9a2.533 2.533 0 0 0-1.961.791 2.483 2.483 0 0 0-.505 2.016l.298 2.627a2.172 2.172 0 0 0 4.338.001l.295-2.608a2.503 2.503 0 0 0-.502-2.034 2.537 2.537 0 0 0-1.963-.793Zm4.161 9.854a6.09 6.09 0 0 1 2.838 4.866.506.506 0 0 1-.501.53H4.509a.506.506 0 0 1-.502-.53 6.09 6.09 0 0 1 2.838-4.866.492.492 0 0 1 .701.102l.311.347a.416.416 0 0 1-.11.704 5.002 5.002 0 0 0-2.055 2.713H16.31a4.944 4.944 0 0 0-2.055-2.713.415.415 0 0 1-.1-.704l.31-.347a.492.492 0 0 1 .702-.102Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconUserStyle0; }
}, [1, "cosmos-icon-user", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-user"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-user":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUser$1);
            }
            break;
    } });
}

const CosmosIconUser = CosmosIconUser$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUser, defineCustomElement };
